import { apiClientsNoTransform } from '@app/services/api/clients'

export default (country, payload, isManualPack) => {
  const client = apiClientsNoTransform[country]
  const url = `1.0/reservations/pack?is_manual_pack=${isManualPack}`
  return client.post(url, payload)
}
